import React from "react";
import styles from "./toursPage.module.css";
import Header from "../../components/header/header";
import Tours from "../../components/tours/tours";
import TourImages from "../../components/tourImages/tourImages";

const ToursPage = (props) => {
  return (
    <div className={styles.container}>
      <Header toursPage={true} />
      <div className={styles.content}>
        <Tours />
        <TourImages />
      </div>
    </div>
  );
};

export default ToursPage;
